/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import { ReactElement } from 'react';
import Picker from '~/view/components/Controls/Pickers/Picker/Picker';
import { IPickerProps } from '~/view/components/Controls/Pickers/Picker/types';
import './style.scss';

export const PickerInsideInput = <T,>(props: IPickerProps<T>): ReactElement => {
  return (
    <Picker
      {...props}
      hideResetIcon={props.hideResetIcon || true}
      hideSelectedIcons={props.hideSelectedIcons || true}
      numberVisibleOptionsInDropdown={props.numberVisibleOptionsInDropdown || 3}
      className={classNames('picker-inside-input', props.className)}
    />
  );
};
